/** @typedef {{ rank: number, suit: number }} Card — rank 2..14 (14=A), suit 0..3 */

const RANK_NAMES = ['2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K', 'A'];
const SUIT_SYMBOLS = ['♣', '♦', '♥', '♠'];

/** rank 2..14, suit 0..3 */
export function makeCard(rank, suit) {
  return { rank, suit };
}

/** Drops null/undefined or malformed entries (partial deal, empty deck). */
export function pokerCardsOnly(arr) {
  if (!arr || !arr.length) return [];
  return arr.filter(
    (c) => c != null && typeof c.rank === 'number' && typeof c.suit === 'number',
  );
}

export function cardToString(c) {
  if (!c) return '';
  const r = RANK_NAMES[c.rank - 2] || '?';
  return r + SUIT_SYMBOLS[c.suit];
}

export function createDeck() {
  const deck = [];
  for (let s = 0; s < 4; s += 1) {
    for (let r = 2; r <= 14; r += 1) {
      deck.push(makeCard(r, s));
    }
  }
  return deck;
}

/** Fisher–Yates */
export function shuffleDeck(deck, rng = Math.random) {
  const d = deck.slice();
  for (let i = d.length - 1; i > 0; i -= 1) {
    const j = Math.floor(rng() * (i + 1));
    [d[i], d[j]] = [d[j], d[i]];
  }
  return d;
}
